export default "__VITE_ASSET__txsjjiXM__"